const DropdownSeparator = () => {
    return <hr className="my-1" />;
};

export default DropdownSeparator;
